module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.hasUnfinishedIteration) ? _c('div', {
    staticClass: "col-12"
  }, [(_vm.hasUnfinishedIteration) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "info",
      "data-publish-result": "waiting"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.iterations.has-unfinished')))]) : _vm._e()], 1) : _vm._e(), (_vm.campaign.customer && _vm.campaign.status) ? _c('div', {
    staticClass: "col-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("pos.campaign.title", {
    'name': _vm.campaign.customer.name,
    'code': _vm.campaign.status.code,
    'remote': _vm.campaign.customer.remote_id
  })))])]) : _vm._e(), (_vm.activeIssues) ? _c('div', {
    staticClass: "col-12"
  }, _vm._l((_vm.activeIssues), function(issue) {
    return _c('div', {
      staticClass: "row issue"
    }, [_c('div', {
      staticClass: "col-2 icon"
    }, [_c('icon', {
      attrs: {
        "name": "exclamation-triangle",
        "scale": "4"
      }
    })], 1), _c('div', {
      staticClass: "col-10"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t(("terms.issues." + issue + ".title"))) + ": " + _vm._s(_vm.$t(("terms.issues." + issue + ".description"))))]), (issue === 'disapproved' && _vm.disapprovalMessages) ? _c('ul', _vm._l((_vm.disapprovalMessages), function(disapprovalMessage) {
      return _c('li', [_vm._v(_vm._s(disapprovalMessage))])
    })) : _vm._e()])])
  })) : _vm._e(), _c('div', {
    staticClass: "col-12"
  }, [(_vm.allCreatives.BRIEF.length || _vm.allCreatives.ONBOARDING.length) ? [_vm._l((_vm.allCreatives.BRIEF.concat(_vm.allCreatives.ONBOARDING)), function(creative, key) {
    return [(!creative.reject_reasons) ? _c('campaign-notification', {
      key: key,
      staticClass: "mb-2",
      attrs: {
        "title": _vm.$t("pos.campaign.tell-us-about-your-business"),
        "link": {
          text: _vm.$t("pos.campaign.provide-a-brief-for-your-ad"),
          to: {
            name: "creative",
            params: {
              id: creative.id
            }
          }
        }
      }
    }) : _c('campaign-notification', {
      staticClass: "mb-2",
      attrs: {
        "title": _vm.$t("pos.campaign.your-brief-was-rejected-because-inclompleted"),
        "link": {
          text: _vm.$t("pos.campaign.check-creative-team-feedback-and-provide-a-new-brief"),
          to: {
            name: "creative",
            params: {
              id: creative.id
            }
          }
        }
      }
    })]
  })] : _vm._e(), (_vm.allCreatives.WIP.length) ? _vm._l((_vm.allCreatives.WIP), function(creative, key) {
    return _c('campaign-notification', {
      key: key,
      staticClass: "mb-2",
      attrs: {
        "icon": "gears",
        "title": _vm.$t("pos.campaign.your-ad-is-currently-being-prepared"),
        "link": _vm.canViewLinkToWIPCreative ? {
          text: _vm.$t("pos.campaign.view-creative"),
          to: {
            name: "creative",
            params: {
              id: creative.id
            }
          }
        } : null
      }
    })
  }) : _vm._e(), (_vm.allCreatives.HOLD.length) ? _vm._l((_vm.allCreatives.HOLD), function(creative, key) {
    return _c('campaign-notification', {
      key: key,
      staticClass: "mb-2",
      attrs: {
        "icon": "gears",
        "title": _vm.$t("pos.campaign.ad-is-ready-for-review-hold"),
        "link": _vm.canViewLinkToWIPCreative ? {
          text: _vm.$t("pos.campaign.view-creative"),
          to: {
            name: "creative",
            params: {
              id: creative.id
            }
          }
        } : null
      }
    })
  }) : _vm._e(), (_vm.allCreatives.READY) ? _vm._l((_vm.allCreatives.READY), function(creative, key) {
    return _c('campaign-notification', {
      key: key,
      staticClass: "mb-2",
      attrs: {
        "title": _vm.$t("pos.campaign.your-ad-is-ready-for-review"),
        "link": {
          text: _vm.$t("pos.campaign.check-it-out-and-share-your-feedback"),
          to: {
            name: "creative",
            params: {
              id: creative.id
            }
          }
        }
      }
    })
  }) : _vm._e(), (_vm.isStatus(_vm.statuses.CAP)) ? [_c('campaign-notification', {
    staticClass: "mb-2",
    attrs: {
      "icon": "image",
      "title": _vm.$t("pos.campaign.your-ad-is-approved")
    }
  })] : _vm._e(), (!_vm.facebookPage && _vm.permissions.includes("updateFacebookPage")) ? [_c('campaign-notification', {
    staticClass: "mb-2",
    attrs: {
      "title": _vm.$t("pos.campaign.connect-your-facebook-page"),
      "description": _vm.$t("pos.campaign.if-you-do-it-will-benefit"),
      "filled": "filled"
    }
  }, [_c('b-btn', {
    attrs: {
      "slot": "right",
      "variant": "outline-white"
    },
    on: {
      "click": _vm.onFillFacebookPage
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.connect')))])], 1)] : _vm._e()], 2), (_vm.isStatus(_vm.statuses.ONL, _vm.statuses.FIN) && _vm.canSeeSuspended) ? _c('div', {
    staticClass: "col-12"
  }, [_c('fill-status', {
    attrs: {
      "title": _vm.$t("pos.campaign.lifetime-stats"),
      "checked": _vm.readyForCAP,
      "hideChecked": false
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "button-container"
  }, [(_vm.isStatus(_vm.statuses.FIN) && _vm.canSeeSuspended && !_vm.subscriptionsEnabled) ? _c('div', {
    staticClass: "col-12 text-center mb-3"
  }, [_c('gotu-nav-button', {
    staticClass: "btn-block",
    attrs: {
      "theme": "default-cta",
      "className": "btn-block",
      "dataTest": _vm.reportPath
    },
    nativeOn: {
      "click": function($event) {
        _vm.downloadReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.pdf-download')))])], 1) : _vm._e(), (_vm.isStatus(_vm.statuses.FIN) || _vm.isStatus(_vm.statuses.ONL) && _vm.canSeeSuspended) ? _c('div', {
    staticClass: "col-12 mb-1"
  }, [(_vm.permissions.includes("downloadLeads")) ? _c('gotu-nav-button', {
    staticClass: "btn-block",
    attrs: {
      "theme": "default-cta",
      "className": "btn-block ",
      "dataTest": _vm.leadReportPath
    },
    nativeOn: {
      "click": function($event) {
        _vm.downloadLeadsReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.leads-download')))]) : _vm._e()], 1) : _vm._e()]), (_vm.isStatus(_vm.statuses.ONL, _vm.statuses.FIN)) ? _c('div', {
    staticClass: "col-12"
  }, [(_vm.canSeeSuspended) ? [_c('campaign-stats'), (_vm.hasIterations) ? _c('iterations-calendar') : _vm._e()] : [_c('h5', [_vm._v(_vm._s(_vm.$t('pos.campaign.suspended.title')))]), _c('p', [_vm._v(_vm._s(_vm.$t('pos.campaign.suspended.details')))]), _c('a', {
    staticClass: "phone btn btn-success",
    attrs: {
      "href": _vm.suspenedPhone
    }
  }, [_c('icon', {
    attrs: {
      "name": "phone"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('pos.campaign.suspended.phone')))])], 1)]], 2) : _vm._e(), (_vm.canSeeSuspended) ? _c('div', {
    staticClass: "col-12"
  }, [_c('campaign-creatives')], 1) : _vm._e(), (_vm.canSeeSuspended) ? _c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('creative-refresh')], 1) : _vm._e(), (_vm.canViewTimeline) ? _c('div', {
    staticClass: "col-12 mt-5"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('pos.timeline.title.campaign')))]), _c('hr'), _c('timeline', {
    attrs: {
      "items": _vm.campaign.timeline
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87979e9e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/campaign-step/CampaignStep.vue
// module id = 2078
// module chunks = 1